module.exports = __webpack_public_path__ + "img/1487899132.243a37ec.jpg";